//Componentes generales
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProviderList from "../../components/ProviderList/ProviderList";

//Context
import proveedoresContext from "../../context/proveedores/proveedoresContext";
import authContext from "../../context/authentication/authContex";

// Alertas
import Swal from "sweetalert2";

//Estilos
import "./Provider.css";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

/* 
    Vista donde se gestiona toda la lógica de listado de proveedores.
    Donde props no se encuentra en uso.
*/
function Provider(props) {
  //Context Auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context proveedores
  const pContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores, actualizarProveedoresDB } =
    pContext;

  const navigate = useNavigate();

  /* 
        Disparador que se ejecuta ante la renderización del componente. El mismo se encarga de actualizar los proveedores disponibles del context.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarProveedores();
    };
    fn();

  }, []);

  const handleBack = () => {
    navigate("/abms");
  };

  /* 
        Manejador que se encarga de la actualización de proveedores que sobreescribe los proveedores actuales por los recuperados de Softland.
    */
  const handlerActualizarProveedores = async () => {
    Swal.fire({
      title: "Desea actualizar la lista de proveedores?",
      text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: "No, cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await actualizarProveedoresDB(usuario._id, usuario.userName)
          .then((response) => {
            if (!response.status) {
              throw new Error(response.msg);
            }
            return response;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Actualizado!",
          "La base de datos ha sido actualizada correctamente.",
          "success"
        );
      }
    });
  };

  return (
    <div className="container-list">
      <div className="back-button-container">
        <button className="back-btn" onClick={handleBack}>
          <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "5px" }} />
        </button>
      </div>
      <div className="actualiza-providers-container">
        <button
          className="actualizar-providers-btn"
          onClick={handlerActualizarProveedores}
        >
          Actualizar Proveedores
        </button>
      </div>
      <ProviderList proveedores={proveedores} />
    </div>
  );
}

export default Provider;